import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Meta } from '../../angular2-meta';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-share-folder',
  template: `
    <nns-top flex="none"
      *ngIf="!visual.isEmbed || (visual.isEmbed && share.parent && !visual.isWordpress)"
      [note]="folder"
      [visual]="visual"
      [login]="login"
      [share]="share"
      [shareCopy]="shareCopy"
      [branding]="branding"
      [profile]="profile"
      class="nns-top-folders"
      [ngClass]="{
        'nns-top-fixed': visual.isHeaderFixed && !visual.isEmbed,
        'nns-top-empty': !share.parent && (branding && !branding.sharesShareButton && !branding.sharesAllowPrint)
      }"
    ></nns-top>
    <div *ngIf="isPending; then isntLoaded; else isLoaded"></div>
    <ng-template #isntLoaded>
    </ng-template>
    <ng-template #isLoaded>
      <nns-folder flex="noshrink" layout="column"
        [folder]="folder"
        [children]="children"
        [share]="share"
        [visual]="visual"
        flex="noshrink"
      ></nns-folder>
      <nns-spam
        *ngIf="!visual.isEmbed && !visual.isPreview && !share.instance.orgTitle"
        flex="none" layout="row" layout-align="start start"
        class="nns-spam-link-reverse"
      ></nns-spam>
    </ng-template>
  `,
  styles: [`
    nns-top {
      position:relative;
      left:0;
      top:0;
      position: relative;
      z-index: 1;
    }

    :host-context(.no-flex) nns-folder {
      display: block;
    }
    .nns-folder-loader {
      box-sizing: border-box;
      max-width: 986px;
      margin: 0 auto;
      padding: 0 26px;
    }
  `, `
    @media only screen and (max-width: 768px) {
      nns-top{
        display: none;
      }
      :host-context(.nns-embed) nns-top{
        display: block;
      }
    }
  `]
})
export class ShareFolderComponent implements OnInit, OnChanges {
  @Input() folder;
  @Input() parent;
  @Input() share;
  @Input() login;
  @Input() children;
  @Input() visual;
  @Input() shareCopy;
  @Input() isPending;
  @Input() branding;
  @Input() profile;

  constructor(
    public _meta: Meta,
  ) {}

  ngOnInit() {
  }

  ngOnChanges() {
    this.setMeta();
  }

  setMeta() {
    let brandingSMMImage = null;
    if(this.share && this.share.instance && this.share.instance.brandingProfile) {
      brandingSMMImage = {
        type: 'image',
        mime: 'image/png',
        attachmentURL:  `/file/${this.share.instance.brandingProfile.sharesSMMImageStoredFileUUID}`,
      }
    }
    const attachment = brandingSMMImage || null;
    this._meta.setMetaForNode(this.share, this.folder, null, attachment)
  }
}
